var $j = jQuery.noConflict();
var ProductMediaManager = {
  IMAGE_ZOOM_THRESHOLD: 20,
  zoomEnabled: Modernizr.mq("screen and (min-width:768px)"),
  imageWrapper: null,

  destroyZoom: function() {
    $j('.zoomContainer').remove();
    $j('.product-image-gallery .gallery-image').removeData('elevateZoom');
  },

  createZoom: function(image) {
    ProductMediaManager.destroyZoom();

    if(!ProductMediaManager.zoomEnabled) { //zoom not enabled
      return;
    }

    if(image.length <= 0) { //no image found
      return;
    }

    if(image[0].naturalWidth && image[0].naturalHeight) {
      var widthDiff = image[0].naturalWidth - image.width() - ProductMediaManager.IMAGE_ZOOM_THRESHOLD;
      var heightDiff = image[0].naturalHeight - image.height() - ProductMediaManager.IMAGE_ZOOM_THRESHOLD;

      if(widthDiff < 0 && heightDiff < 0) {
        //image not big enough

        image.parents('.product-image').removeClass('zoom-available');

        return;
      } else {
        image.parents('.product-image').addClass('zoom-available');
      }
    }

    image.elevateZoom();
  },

  swapImage: function(targetImage) {
    targetImage = $j(targetImage);
    targetImage.addClass('gallery-image');

    ProductMediaManager.destroyZoom();

    var imageGallery = $j('.product-image-gallery');

    if(targetImage[0].complete) { //image already loaded -- swap immediately

      imageGallery.find('.gallery-image').removeClass('visible');

      //move target image to correct place, in case it's necessary
      imageGallery.append(targetImage);

      //reveal new image
      targetImage.addClass('visible');

      //wire zoom on new image
      ProductMediaManager.createZoom(targetImage);

    } else { //need to wait for image to load

      //add spinner
      imageGallery.addClass('loading');

      //move target image to correct place, in case it's necessary
      imageGallery.append(targetImage);

      //wait until image is loaded
      imagesLoaded(targetImage, function() {
        //remove spinner
        imageGallery.removeClass('loading');

        //hide old image
        imageGallery.find('.gallery-image').removeClass('visible');

        //reveal new image
        targetImage.addClass('visible');

        //wire zoom on new image
        ProductMediaManager.createZoom(targetImage);
      });

    }
  },

  wireThumbnails: function() {
    //trigger image change event on thumbnail click
    $j('.product-image-thumbs .thumb-link').click(function(e) {
      e.preventDefault();
      var jlink = $j(this);
      var target = $j('#image-' + jlink.data('image-index'));

      ProductMediaManager.swapImage(target);
    });
  },

  initZoom: function() {
    ProductMediaManager.createZoom($j(".no-touch .gallery-image.visible")); //set zoom on first image
  },

  init: function() {
    ProductMediaManager.imageWrapper = $j('.product-img-box');

    enquire.register("screen and (min-width:768px)", {
      match : function() {
        ProductMediaManager.zoomEnabled = true;
        ProductMediaManager.initZoom();
      },
      unmatch : function() {
        ProductMediaManager.destroyZoom();
        ProductMediaManager.zoomEnabled = false;
      }
    });

    //resizing the window causes problems with zoom -- reinitialize
    $j(window).on('delayed-resize', function(e, resizeEvent) {
      ProductMediaManager.destroyZoom();
      ProductMediaManager.initZoom();
    });

    ProductMediaManager.wireThumbnails();

    $j(document).trigger('product-media-loaded', ProductMediaManager);
  }
};

$j(document).ready(function() {
  ProductMediaManager.init();
});
